import { Skeleton } from '@app/components/various/Skeleton';

import { SplitHeader, SplitRow } from './SplitRow';

export const CheckoutOrdersSkeleton = () => {
  return (
    <div>
      <SplitHeader>
        <div className="-ml-4 max-w-32">
          <Skeleton type="text" size="large" />
        </div>
        <div className="invisible max-w-20 sm:visible">
          <Skeleton type="text" size="small" />
        </div>
        <div className="invisible flex w-full justify-end sm:visible">
          <div className="w-full max-w-24">
            <Skeleton type="text" size="small" />
          </div>
        </div>
      </SplitHeader>

      <div className="mt-2 overflow-hidden rounded-regular bg-white">
        <SplitRow>
          <div className="col-span-full sm:col-auto">
            <div className="mb-2 max-w-32">
              <Skeleton type="text" size="large" />
            </div>
            <div className="max-w-64">
              <Skeleton type="text" size="small" />
            </div>
          </div>

          <div className="flex gap-2">
            <div className="sm:hidden">
              <Skeleton type="text" size="small" />
            </div>
            <div className="w-full max-w-24">
              <Skeleton type="text" size="small" />
            </div>
          </div>

          <div className="flex justify-end gap-2 body-2">
            <div className="sm:hidden">
              <Skeleton type="text" size="small" />
            </div>
            <div className="w-full max-w-28">
              <Skeleton type="text" size="small" />
            </div>
          </div>

          <Skeleton type="rectangle" className="absolute right-3 top-3 size-5 shrink-0 sm:static" />
        </SplitRow>
      </div>
    </div>
  );
};
